import PropTypes from 'prop-types';
import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';

import { useUser } from 'queries/Users';
import Avatar from 'components/Avatar';

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

export default function NavbarAccount({ isCollapse }) {
  const { iconId, name, role } = useUser();

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link underline="none" color="inherit">
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
        <Box flex={1} maxWidth="40px">
          <Avatar iconId={iconId} />
        </Box>

        {!isCollapse && (
          <Box
            sx={{
              ml: 2,
              transition: (theme) =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.shorter,
                }),
              ...(isCollapse && {
                ml: 0,
                width: 0,
              }),
            }}
          >
            {name && (
              <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
                {name}
              </Typography>
            )}
            {role && <Typography sx={{ color: 'text.secondary', fontSize: 10 }}>{role}</Typography>}
          </Box>
        )}
      </RootStyle>
    </Link>
  );
}

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};
